<mat-dialog-content>
  <lemon-dialog-header> Siirrä kirjaus </lemon-dialog-header>

  <div class="tosite-tiedot">
    <form novalidate style="margin: 0">
      <mat-form-field>
        <mat-label>Päivämäärä</mat-label>
        <input type="text" [max]="viimeinenPaiva" [min]="ensimmainenPaiva" [matDatepicker]="picker" [formField]="lomake.kirjauksenPvm" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-error>Päivämäärä puuttuu</mat-error>
      </mat-form-field>
      <mat-datepicker #picker></mat-datepicker>

      <mat-form-field>
        <mat-label>Maksutapa</mat-label>
        <mat-select [formField]="lomake.maksutapa">
          @for (mt of kaytettavatMaksutavat; track mt) {
            <mat-option [value]="'' + mt.tunniste">{{ mt.nimi }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: space-around; justify-content: space-evenly">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (kirjauksen siirto dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="siirra()" actionId="Siirrä kirjaus" [actionContext]="$any(lomake().value())">Siirrä</app-primary-button>
</mat-dialog-actions>
